/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as ResponseDefault } from './response-default.story';
export { default as ResponseStreaming } from './response-streaming.story';
export { default as ResponseAllComponents } from './response-all-components.story';
export { default as ResponseCodeExamples } from './response-code-examples.story';
export { default as ResponseHeadings } from './response-headings.story';
export { default as ResponseLists } from './response-lists.story';
export { default as ResponseFullExample } from './response-full-example.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import ResponseAllComponentsSourceRaw from './response-all-components.story?raw';
import ResponseCodeExamplesSourceRaw from './response-code-examples.story?raw';
import ResponseDefaultSourceRaw from './response-default.story?raw';
import ResponseFullExampleSourceRaw from './response-full-example.story?raw';
import ResponseHeadingsSourceRaw from './response-headings.story?raw';
import ResponseListsSourceRaw from './response-lists.story?raw';
import ResponseStreamingSourceRaw from './response-streaming.story?raw';

export const ResponseDefaultSource = removeLicenseHeader(
  ResponseDefaultSourceRaw,
);
export const ResponseStreamingSource = removeLicenseHeader(
  ResponseStreamingSourceRaw,
);
export const ResponseAllComponentsSource = removeLicenseHeader(
  ResponseAllComponentsSourceRaw,
);
export const ResponseCodeExamplesSource = removeLicenseHeader(
  ResponseCodeExamplesSourceRaw,
);
export const ResponseHeadingsSource = removeLicenseHeader(
  ResponseHeadingsSourceRaw,
);
export const ResponseListsSource = removeLicenseHeader(ResponseListsSourceRaw);
export const ResponseFullExampleSource = removeLicenseHeader(
  ResponseFullExampleSourceRaw,
);
